import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { PropType } from 'vue';
import ActivityForm from '@/modules/CMS/components/ActivityForm.vue';
import type ActivityFormConfiguration from '@/models/interfaces/ActivityFormConfiguration';
import type StatusEventConfiguration from '@/models/interfaces/StatusEventConfiguration';
import type { AutomaticEventSelectOption } from '@/modules/CMS/interfaces/AutomaticEventSelectOption';
import type { StatusEventFormSubmission } from '@/modules/CMS/interfaces/StatusEventFormSubmission';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewStatusEvent',
  props: {
    initialStatusEvent: {
        default: null as StatusEventConfiguration | null,
    },
    initialActivityTemplate: {
        default: null as ActivityFormConfiguration | null,
    },
    labels: {
        type: Array as PropType<AutomaticEventSelectOption[]>,
        default: () => [],
    },
    activityTypes: {
        type: Array as PropType<AutomaticEventSelectOption[]>,
        default: () => [],
    },
    activeUsers: {
        type: Array as PropType<AutomaticEventSelectOption[]>,
        default: () => [],
    },
},
  emits: ["submit"],
  setup(__props, { expose, emit }: { emit: ({
    (event: 'submit', payload: StatusEventFormSubmission): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





// Main object for creating event configuration
const formData = ref<StatusEventConfiguration>({
    name: null,
    labelName: null,
    labelId: null,
    status: 'ACTIVE',
    statusChange: 'BEFORE',
    type: 'EMAIL',
    conditions: {
        selectedTimeStep: null,
        timeUnit: null,
        email: null,
    },
    receptionUsers: [],
});

const activityForm = ref<ActivityFormConfiguration>({
    name: null,
    note: null,
    activityType: null,
    responsiblePersonType: null,
});

const emailSendToOptions: string[] = ['CREATOR', 'COMMERCIALIST', 'CLIENT'];
const statusOptions: string[] = ['ACTIVE', 'ARCHIVED'];
const statusChange: string[] = ['BEFORE', 'AFTER'];
const types: string[] = ['EMAIL', 'POPUP'];
const timeUnitOptions: string[] = ['days', 'hours', 'minutes', 'seconds'];
const emailAttachmentOptions: string[] = ['lead', 'offer', 'order', 'all'];

const isPopup = computed(() => formData.value.type === 'POPUP');

function updateActivityForm(data: any) {
    activityForm.value = {
        ...data,
    };
}

if (props.initialStatusEvent) {
    formData.value = {
        ...props.initialStatusEvent,
        conditions: {
            selectedTimeStep: null,
            timeUnit: null,
            email: null,
            ...props.initialStatusEvent.conditions,
        },
        receptionUsers: [...(props.initialStatusEvent.receptionUsers ?? [])],
    };
}

if (props.initialActivityTemplate) {
    activityForm.value = { ...props.initialActivityTemplate };
}

function submit() {
    emit('submit', {
        statusEvent: {
            ...formData.value,
            conditions: { ...formData.value.conditions! },
            receptionUsers: [...(formData.value.receptionUsers ?? [])],
        },
        activityTemplate: { ...activityForm.value },
    });
}

expose({ submit });

return { __sfc: true,props, emit, formData, activityForm, emailSendToOptions, statusOptions, statusChange, types, timeUnitOptions, emailAttachmentOptions, isPopup, updateActivityForm, submit, ActivityForm }
}

})